<template>
	<transition name="scroll">
		<div
			v-if=" scrollY < 300 "
			class="iv2-home__scroll-bar theme-b__scroll position-fixed d-none d-xl-block text-center"
		>
			<span class="iv2-home__scroll-bar-text">Scroll</span>
		</div>
	</transition>
</template>

<script>
export default {
	data() {
		return {
			scrollY: 0,
		};
	},

	mounted() {
		window.addEventListener("scroll", this.handleScroll);
	},

	methods: {
		handleScroll() {
			this.scrollY = window.scrollY;
		},

		scrollTop: function () {
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		},
	},
};
</script>

<style lang="scss">
.iv2-home__scroll-bar {
	right: 0px;
	bottom: 0px;
	width: 20px;
	height: 110px;
	margin: 0 30px;
	font-size: 14px;
	font-weight: 400;
	letter-spacing: 0.5px;
	z-index: 9;

	&::before {
		content: "";
		width: 15px;
		height: 15px;
		border-left: 1px solid;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		position: absolute;
		left: 8px;
		bottom: 3px;
	}

	&::after {
		content: "";
		height: 50px;
		width: 1px;
		position: absolute;
		left: 5px;
		bottom: 10px;
	}

	.iv2-home__scroll-bar-text {
		transform: rotate(90deg);
		display: block;
		word-break: initial;
	}

	&.scroll-enter-active,
	&.scroll-leave-active {
		transition: all 1s ease;
	}

	&.scroll-enter,
	&.scroll-leave-to {
		transform: translateY(-150px) !important;
		opacity: 0;
	}
}
</style>
